import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/component/layout/layout.component';
import { AccessdeniedComponent } from './shared/components/accessdenied/accessdenied.component';
import { NotfoundComponent } from './shared/components/notfound/notfound.component';
import { authGuard, noAuthGuard, roleGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./auth/auth.routes')
    },
    {
        path: 'dd',
        component: LayoutComponent,
        canActivate: [authGuard],
        children: [
            {
                path: 'cp',
                canActivate: [roleGuard],
                data: { roles: ['admin', 'manager', 'warehouse_operator', 'delivery_person'] },
                loadChildren: () => import('./modules/distrident/views/control-panel/control-panel-views.routes')
            },
            {
                path: 'cl',
                canActivate: [roleGuard],
                data: { roles: ['cliente', 'admin', 'manager', 'delivery_person', 'warehouse_operator'] },
                loadChildren: () => import('./modules/distrident/views/client-panel/client-panel-views.routes')
            }
        ]
    },
    {
        path: 'auth',
        canActivate: [noAuthGuard],
        loadChildren: () => import('./auth/auth.routes')
    },
    { path: 'notfound', component: NotfoundComponent },
    { path: 'denied', component: AccessdeniedComponent },

    { path: '**', redirectTo: '/notfound' }
];
